/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_View_Audit_LogInputs */



/**
* | output |
* | --- |
* | "View Audit Log" |
*
* @param {Leveling_Perm_View_Audit_LogInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_view_audit_log = /** @type {((inputs?: Leveling_Perm_View_Audit_LogInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_View_Audit_LogInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просматривать журнал аудита")
	return /** @type {LocalizedString} */ ("View Audit Log")
});